
import { Alert, AlertDescription } from "@/components/ui/alert";

interface AuthAlertsProps {
  showConfirmMessage: boolean;
  errorMessage: string | null;
}

const AuthAlerts = ({ showConfirmMessage, errorMessage }: AuthAlertsProps) => {
  if (!showConfirmMessage && !errorMessage) return null;
  
  return (
    <>
      {showConfirmMessage && (
        <Alert className="mb-6 bg-blue-50 border-blue-200">
          <AlertDescription>
            Registreerimine õnnestus! Palun kontrolli oma postkasti ja kinnita konto, klikkides saadetud e-kirjas olevale lingile. Pärast kinnitamist suunatakse sind sisselogimise lehele.
          </AlertDescription>
        </Alert>
      )}
      
      {errorMessage && (
        <Alert className="mb-6 bg-red-50 border-red-200">
          <AlertDescription>{errorMessage}</AlertDescription>
        </Alert>
      )}
    </>
  );
};

export default AuthAlerts;
